import e from "react";
import l from "prop-types";
import { range as h } from "lodash";
import { u as b } from "./utils-C0l876fA.es.js";
import g from "classnames";
import { S as _ } from "./ShimmerBlock-hNiBn9_0.es.js";
import './DataTableShimmer.css';const s = {
  "header-table-large": "HeaderShimmer-module__header-table-large___wPvD3",
  "header-table-normal": "HeaderShimmer-module__header-table-normal___iB9q9",
  "header-large": "HeaderShimmer-module__header-large___OkimB",
  "header-normal": "HeaderShimmer-module__header-normal___JROKR",
  "header-row": "HeaderShimmer-module__header-row___mei9Q"
}, p = (o) => {
  const { numCols: r } = o, m = () => /* @__PURE__ */ e.createElement("th", { className: s["header-table-normal"], role: "columnheader" }, /* @__PURE__ */ e.createElement(_, { className: s["header-normal"] }));
  return /* @__PURE__ */ e.createElement("thead", null, /* @__PURE__ */ e.createElement("tr", { className: s["header-row"], role: "row" }, /* @__PURE__ */ e.createElement(
    "th",
    {
      className: s["header-table-large"],
      role: "columnheader"
    },
    /* @__PURE__ */ e.createElement(_, { className: s["header-large"] })
  ), h(r - 1).map((a) => /* @__PURE__ */ e.createElement(m, { key: a }))));
};
p.propTypes = {
  /** nu */
  numCols: l.number.isRequired
};
const f = "BodyShimmer-module__body___D7qPI", E = "BodyShimmer-module__small___BpEsa", B = "BodyShimmer-module__medium___WiAbO", w = "BodyShimmer-module__large___HQrPw", n = {
  body: f,
  "first-small": "BodyShimmer-module__first-small___7WyZQ",
  "first-medium": "BodyShimmer-module__first-medium___amCl4",
  "first-large": "BodyShimmer-module__first-large___0yxz0",
  small: E,
  medium: B,
  large: w,
  "body-first-small": "BodyShimmer-module__body-first-small___W7QCN",
  "body-first-medium": "BodyShimmer-module__body-first-medium___EmOJq",
  "body-first-large": "BodyShimmer-module__body-first-large___CBo-H",
  "body-small": "BodyShimmer-module__body-small___f0orx",
  "body-medium": "BodyShimmer-module__body-medium___7wkjE",
  "body-large": "BodyShimmer-module__body-large___2HG70",
  "small-spacer": "BodyShimmer-module__small-spacer___dMeQZ",
  "big-spacer": "BodyShimmer-module__big-spacer___5e2-z",
  "body-row": "BodyShimmer-module__body-row___MBkuy"
}, u = (o) => {
  const { shimmerStyle: r, spacerStyle: m } = o;
  return /* @__PURE__ */ e.createElement("td", { className: n[m], role: "cell" }, /* @__PURE__ */ e.createElement(
    _,
    {
      className: g(n.body, n[r])
    }
  ));
};
u.propTypes = {
  shimmerStyle: l.string.isRequired,
  spacerStyle: l.string.isRequired
};
const y = (o) => {
  const { size: r, numCols: m, spacerStyle: a } = o, t = `first-${r}`, i = h(m - 1).map((d) => /* @__PURE__ */ e.createElement(
    u,
    {
      key: d + 1,
      shimmerStyle: r,
      spacerStyle: a
    }
  ));
  return /* @__PURE__ */ e.createElement("tr", { role: "row" }, /* @__PURE__ */ e.createElement(
    u,
    {
      key: 0,
      shimmerStyle: t,
      spacerStyle: a
    }
  ), i);
};
y.propTypes = {
  numCols: l.number.isRequired,
  size: l.oneOf(["small", "medium", "large"]).isRequired,
  spacerStyle: l.string.isRequired
};
const S = (o) => {
  const { t: r } = b(), { numCols: m, numRows: a } = o, t = ["large", "small", "medium"], i = h(a - 1).map((d) => /* @__PURE__ */ e.createElement(
    y,
    {
      key: d,
      size: t[d % t.length],
      numCols: m,
      spacerStyle: "small-spacer"
    }
  ));
  return /* @__PURE__ */ e.createElement("tbody", { "aria-label": r("loading") }, i, /* @__PURE__ */ e.createElement(
    y,
    {
      key: a - 1,
      size: t[(a - 1) % t.length],
      numCols: m,
      spacerStyle: "large-spacer"
    }
  ));
};
S.propTypes = {
  /** number of shimmer rows to render aka height */
  numRows: l.number.isRequired,
  /** number of shimmer columns to render aka width */
  numCols: l.number.isRequired
};
const c = {
  "footer-upper-rectangle": "FooterShimmer-module__footer-upper-rectangle___96IMe",
  "big-spacer": "FooterShimmer-module__big-spacer___pteyD",
  "footer-lower-rectangle": "FooterShimmer-module__footer-lower-rectangle___OR-qU"
}, R = () => /* @__PURE__ */ e.createElement("div", { className: c["big-spacer"], "data-testid": "shimmer-load-more" }, /* @__PURE__ */ e.createElement(_, { className: c["footer-upper-rectangle"] }), /* @__PURE__ */ e.createElement(_, { className: c["footer-lower-rectangle"] })), q = "DataTableShimmer-module__table___6szSx", C = {
  table: q
}, N = (o) => {
  const { numCols: r, numRows: m } = o;
  return /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("table", { className: C.table }, /* @__PURE__ */ e.createElement(p, { numCols: r }), /* @__PURE__ */ e.createElement(S, { numCols: r, numRows: m })), /* @__PURE__ */ e.createElement("div", null, /* @__PURE__ */ e.createElement(R, null)));
};
N.propTypes = {
  /** number of shimmer rows to render aka height */
  numRows: l.number.isRequired,
  /** number of shimmer columns to render aka width */
  numCols: l.number.isRequired
};
export {
  S as B,
  N as D,
  R as F,
  p as H
};
